import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-confirmationmodal',
  templateUrl: './confirmationmodal.component.html',
  styleUrls: ['./confirmationmodal.component.scss']
})
export class ConfirmationmodalComponent implements OnInit {
  onClose: any;
  onConfirm: any;

  @Input() title: any = null;
  @Input() content: string = '';

  constructor() { }

  ngOnInit() {
  }

  close(){
    this.onClose();
  }

  confirm(){
    this.onConfirm();
  }

}
